<div class="dvb-transaktion-zuweisen">
    <dvb-transaktion-zuweisen-header bank-statement-entry="vm.bankStatementEntry">
    </dvb-transaktion-zuweisen-header>

    <div ui-view></div>
</div>
